import { render, staticRenderFns } from "./UiContentFrameList.vue?vue&type=template&id=a2917428"
import script from "./UiContentFrameList.vue?vue&type=script&lang=js"
export * from "./UiContentFrameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports